import xhr from './xhr'

export default function getJSON (url) {
    return xhr({ url })
}



// WEBPACK FOOTER //
// ./node_modules/nespresso-library/src/utils/getJSON.js